import React, { useEffect } from 'react';
import gsap from 'gsap';
import { useAuth } from '../../auth'
import { useLocation, useNavigate } from 'react-router-dom';
import { getQueryVariable } from '../../core/utils'
import routes from '../../routes'
import "./LoadingScreen.css";
import LoadingLine from '../../components/LoadingLine'
const SIGNIN_PAGE = '/accounts/signin';

export default function CallBack() {
  const navigate = useNavigate();
  const location = useLocation();
  const next = location.state?.from?.pathname;
  const { refetchUser } = useAuth();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const confirm = urlParams.get('confirm');
    const oauth_token_url = `${process.env.REACT_APP_OAUTH_BACKEND_URL}${process.env.REACT_APP_OAUTH_TOKEN_URL}`;

    if (!code) {
      navigate(SIGNIN_PAGE, { state: { error: 'auth_code_missing' } });
      return;
    }

    const codeVerifier = localStorage.getItem('pkce_code_verifier');
    if (!codeVerifier) {
      navigate(SIGNIN_PAGE, { state: { error: 'pkce_missing' } });
      return;
    }

    function redirect() {
      const redirectTo = next || getQueryVariable('next') || routes.projects;
      navigate(redirectTo, {replace: true})
    }

    const timer = setTimeout(() => {
      const payload = {
        code: code,
        code_verifier: codeVerifier,
      };
      if (confirm) {
        payload.confirm = confirm;
      }

      fetch(oauth_token_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        credentials: 'include',
      })
        .then((res) => {
          if (res.status === 302) {
            navigate("/oauth/confirm", {state: { from: location.pathname }});
            return null;
          }
          if (res.status === 403) {
            navigate(SIGNIN_PAGE, { state: { error: 'token_exchange_failed' } });
            return null;
          }
          if (!res.ok) {
            throw new Error('Token exchange failed');
          }
          return res.json();
        })
        .then(async (data) => {
          if (!data) return;
          if (data.access) {
            localStorage.removeItem('pkce_code_verifier');
            localStorage.setItem('access', JSON.stringify(data.access));
            localStorage.setItem('refresh', JSON.stringify(data.refresh));
            await refetchUser();

            gsap.to('.loading-container', {
              opacity: 0,
              duration: 0.6,
              ease: "expo.inOut",
              onComplete: () => {
                redirect();
              }
            });

            return
          }
        })
        .catch((err) => {
          navigate(SIGNIN_PAGE, { state: { error: 'invalid_access' } });
        })
    }, 1500);

    return () => clearTimeout(timer);
  }, [navigate, location.state, location.pathname, next, refetchUser]);
  return (
    <div className="loading-container">

      <LoadingLine />
      <div className="loading-text-container">
        <p className="loading-text">로그인 중</p>
      </div>
    </div>
  );
}
